import { redirect } from 'react-router'
import { publicAction } from '@/data/loaders'

export function loadCourses() {
  return publicAction("getMyCourses", {});
}

export function courseAction({ request, params }) {
  return new Promise(function(resolve, reject) {
    request.json().then(function(data) {

      if (data.intent == "createCourse") {

        publicAction("createCourse", data.data).then(function({ data }) {
          resolve(redirect("/courses/"+data.course_id));
        }).catch(function() {
          resolve({success: false, date: Date.now()});
        });

      } else {
        reject(new Error("Invalid intent"));
      }

    })
  })
}

export function joinCourse({ join_code }) {
  return publicAction("joinCourse", { join_code });
}

export function joinCourseViaLink({ request, params }) {
  return new Promise(function(resolve, reject) {

    publicAction("joinCourse", { join_code: params.join_code }).then(function({ data }) {
      if (data.course_id) {
        if (params.assessment_id) {
          resolve(redirect('/courses/'+data.course_id+'/assessments/'+params.assessment_id+'/start'));
        } else {
          resolve(redirect('/courses/'+data.course_id));
        }
      } else {
        reject({text: "Invalid course link", path: "/courses", status: 404 });
      }
    }).catch(reject);

  })
}

export function loadCourse({ request, params }) {
  return new Promise(function(resolve, reject) {
    let pathname = request ? (new URL(request.url)).pathname : "/";

    if (!pathname.match(/^(\/organizations\/[A-Za-z0-9]+)?\/courses\/[A-Za-z0-9]+/)) {
      resolve(redirect("/courses"));
    }

    // if (params.course_id == "new") {
    //   return resolve({});
    // }

    publicAction("getCourse", { id: params.course_id }).then(function({ data }) {
      if (data.value) {
        resolve({data: data});
      } else {
        reject({text: "Course not found", path: "/courses", status: 404 });
      }
    }).catch(reject);

  })
}

export function loadCourseSettings({ request, params }) {
  return new Promise(function(resolve, reject) {

    publicAction("getCourseSettings", { id: params.course_id }).then(function({ data }) {
      if (data.value) {
        resolve({data: data});
      } else {
        reject({text: "Course not found", path: "/courses", status: 404 });
      }
    }).catch(reject);

  })
}

export function loadCourseMembers({ request, params }) {
  return new Promise(function(resolve, reject) {

    publicAction("getCourseMembers", { id: params.course_id }).then(function({ data }) {
      if (data.value) {
        resolve({data: data});
      } else {
        reject({text: "Course not found", path: "/courses", status: 404 });
      }
    }).catch(reject);

  })
}

export function unenrollCourse({ id }) {
  return publicAction("unenrollCourse", { id });
}

export function deleteCourse({ course_id }) {
  return publicAction("deleteCourse", { course_id });
}